import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './symbolInfoPreview.png';

export const symbolInfoCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The symbol info capsule shows key static data for a symbol
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            src: preview,
            altText: 'symbolInfo-preview',
        },
    ],
};
